import React from "react";

//external components
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import RoleForm from "../../Roles-form";
import { RolesResources } from "../../Roles-resources/RolesResources";
import { useParams } from "react-router-dom";

//components

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ pt: 0.5, pb: 0.5 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

export default function RoleTabRoutes({ value, myRoles }) {
  const { rID } = useParams();
  return (
    <>
      <TabPanel value={value} index={0}>
        <RoleForm myRoles={myRoles}/>
      </TabPanel>
      <TabPanel value={value} index={1}>
        <RolesResources myRoles={myRoles} roleGuid={rID}/>
      </TabPanel>
    </>
  );
}
